import React from 'react'
import _ from 'lodash'
import * as slideLayoutJSON from '../slideLayout/slideLayoutDefinition.json'

const throttleInterval=150 //ms

function parseChoicesCeilingHeight(choicesCeilingHeightString){
	const subStr=choicesCeilingHeightString.slice(0,-2)
	return parseInt(subStr,10)
}

const choicesFontSizeChoices=slideLayoutJSON.SpecialValues.ChoicesFontSizeArray

class ChoicesWrapper extends React.PureComponent{

	constructor(){
		super()
		this.calculateFont = _.throttle(this.calculateFont,throttleInterval)	
		this.state={		
			choicesFontSize:0
		}
	}	

 

	componentDidMount(){
		this.mounted=true
		if(this.props.question.xLayout){
			if(this.props.question.xLayout.choiceFS){
				this.setState({choicesFontSize:this.props.question.xLayout.choiceFS})
			}
			else{
				this.calculateFont()
			}
		}else{
			this.calculateFont()
		}
	}

	componentDidUpdate(prevProps) {
		if(this.props.question.questionId!== prevProps.question.questionId){
			if(this.props.question.xLayout){
				if(this.props.question.xLayout.choiceFS){
					this.setState({choicesFontSize:this.props.question.xLayout.choiceFS})
				}else{
					this.calculateFont()
				}
			}else {
				this.calculateFont()
			}
		}
		else if (this.props.question.choices !==prevProps.question.choices || this.props.template !== prevProps.template){
			this.calculateFont()
		}
	}

	componentWillUnmount() {
		this.mounted = false
	}


	calculateFont(){
		const ceilingHeight=parseChoicesCeilingHeight(slideLayoutJSON.SpecialValues.ChoicesCeilingHeight[this.props.template])
		const numOfChoicesFonts=choicesFontSizeChoices.length

		let newChoicesFontsize=choicesFontSizeChoices[0]
		for (var i = (numOfChoicesFonts-1); i >-1; i--) {
			const el =this[`ghost${i}`]
			if(el){
				if((el.clientHeight) < ceilingHeight){
					newChoicesFontsize=choicesFontSizeChoices[i]
					break				
				}
			}
		}
		if(this.mounted){
   			this.setState({choicesFontSize:newChoicesFontsize})
   			this.props.updateFontSizes('choices',newChoicesFontsize)
   		}



	}



	render(){	

		const {choicesFontSize}=this.state
		const {uneditedChoices, isShuffling, isShufflingStart}=this.props
		
		

		const choicesCalcCSS = { 			
			fontSize: `${choicesFontSize}px`,
		}
		

		return[
			React.cloneElement(this.props.children, { style: choicesCalcCSS, className:`slide-choices ${uneditedChoices ? 'slide-choices--incomplete' : 'slide-choices--complete'} ${isShuffling ? 'slide-choices--shuffling' : ''} ${isShufflingStart ? 'slide-choices--shufflingStart' : ''} ${isShuffling && !isShufflingStart ? 'slide-choices--shufflingEnd' : ''}` ,key:'real'})								
		,

			<div key='ghost'>
				{choicesFontSizeChoices.map((fontSize,i) => {
					return(

						React.cloneElement(this.props.children, {key:i, style: {fontSize: `${fontSize}px`} ,ref:c => {this[`ghost${i}`] = c} ,className:'slide-choices is--ghost'} )	
							)
					})}

			</div>
			
		]	
	}	
}

export default ChoicesWrapper









// WEBPACK FOOTER //
// ./src/components/slides/slideWrappers/ChoicesWrapper.js